// @Initial state
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  visitor: null,
  session: null,
  sessionId: null,
  visitorId: null,
  propertyId: null,
  widgetId: null,
  error: "",
  pre_chat: false,
  widgetSettings: null,
  unreadMsgsCount: 0,
  unreadMsgs: null,
  isOpen: false,
};

// @Slice
export const visitorSlice = createSlice({
  name: "visitor",
  initialState,
  reducers: {
    setWidgetId: (state, { payload }) => {
      state.widgetId = payload;
    },
    setPropertyId: (state, { payload }) => {
      state.propertyId = payload;
    },
    setSessionId: (state, { payload }) => {
      state.sessionId = payload;
    },
    setVisitorId: (state, { payload }) => {
      state.visitorId = payload;
    },
    setSession: (state, action) => {
      state.session = action.payload;
    },
    updateVisitor: (state, action) => {
      state.visitor = { ...state.visitor, ...action.payload };
    },
    setVisitor: (state, action) => {
      state.visitor = action.payload;
    },
    setCheckPreChat: (state, action) => {
      state.pre_chat = action.payload;
    },
    setWidgetSettings: (state, action) => {
      state.widgetSettings = action.payload;
    },
    setUnreadMsgsCount: (state, action) => {
      const { type } = action.payload;
      if (type === "increment") {
        state.unreadMsgsCount = state.unreadMsgsCount + 1;
      } else {
        state.unreadMsgsCount = 0;
      }
    },
    setUnreadMsgs: (state, action) => {
      const newMessage = JSON.parse(action.payload);

      // Combine existing unread messages with the new message
      const combinedMessages = [...(state.unreadMsgs || []), newMessage];

      // Deduplicate messages by `lastMessageId`
      const updatedMessages = Array.from(
        new Map(
          combinedMessages.map((msg) => [msg.lastMessageId, msg])
        ).values()
      );

      // Update the state with unique messages
      state.unreadMsgs = updatedMessages;
    },

    setUnreadMsgsNull: (state) => {
      state.unreadMsgs = null;
    },
    setWidgetOpen: (state, action) => {
      state.isOpen = action.payload;
    },
    setVisitorState: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export default visitorSlice.reducer;

export const {
  setPropertyId,
  setSessionId,
  setVisitorId,
  setSession,
  updateVisitor,
  setVisitor,
  setWidgetId,
  setCheckPreChat,
  setWidgetSettings,
  setUnreadMsgsCount,
  setUnreadMsgs,
  setVisitorState,
  setWidgetOpen,
  setUnreadMsgsNull,
} = visitorSlice.actions;
